import useSWR from "swr";
import { useDateFilters } from "../../../hooks/useDateFilters";
import { useUser } from "../../../../../utils/hooks/user";
import { formatDateRange } from "../../../../../utils/helpers/api";

export const useByPayDateRetro = (user) => {
    const loggedUser = useUser();
    const { from, to } = useDateFilters();
    const { data, mutate } = useSWR(() => {
        if (!user?.id || !loggedUser?.permissions?.timeSheet?.canViewRetro) {
            return null;
        }
        return {
            url: `/retro-adjustment/user/${user.id}/by-pay-date`,
            params: {
                ...formatDateRange(from, to),
                pagination: "false",
                status: ["approved", "applied"]
            },
        };
    });
    return { data, mutate };
}
